import Orders from './Orders.styled';

export default Orders;
